var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_591",
    "data-name": "Group 591",
    transform: "translate(-144 -912)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2725",
    "data-name": "Path 2725",
    d: "M155.327,922.633a3.468,3.468,0,0,1-.612-.055A3.588,3.588,0,0,1,152,919.157v-.88a3.588,3.588,0,0,1,2.716-3.421,3.336,3.336,0,0,1,3.951,3.277V919.3a3.332,3.332,0,0,1-3.339,3.332Zm.012-7a2.566,2.566,0,0,0-.475.043,2.75,2.75,0,0,0-2.031,2.6v.88a2.75,2.75,0,0,0,2.031,2.6,2.5,2.5,0,0,0,2.969-2.457v-1.167a2.5,2.5,0,0,0-.9-1.92A2.467,2.467,0,0,0,155.339,915.634Z",
    transform: "translate(-1.333 -0.467)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2726",
    "data-name": "Path 2726",
    d: "M154,932a10,10,0,1,1,10-10A10.011,10.011,0,0,1,154,932Zm0-19.167A9.167,9.167,0,1,0,163.167,922,9.177,9.177,0,0,0,154,912.833Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2727",
    "data-name": "Path 2727",
    d: "M161.143,931.925a.415.415,0,0,1-.381-.247,6.846,6.846,0,0,0-12.3,0,.417.417,0,1,1-.762-.338,7.678,7.678,0,0,1,13.828,0,.417.417,0,0,1-.381.586Z",
    transform: "translate(-0.61 -2.5)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.4c2309d5bb1dc92d93aec0dffa81ff3f.svg";
export { ForwardRef as ReactComponent };